const getters = {
  language: (state) => state.lang.language,
  tableHeight: (state) => state.app.tableHeight,
  tagsViewList: (state) => state.tagsView.visitedViews,
  menuIndexType: (state) => state.menu.indexType,
};
export default getters;
